<template>
  <div class="service-container">
    <h3>客服电话</h3>
    <p>联系电话：{{tell}}</p>
  </div>
</template>

<script>
import {ApiGetcustomService} from '../../../net/course/index.js'
export default {
  data: function () {
    return {
      tell: ''
    }
  },
  methods: {
    getTell: function () {
      ApiGetcustomService({phoneType: 'pc'}).then(res=>{
        this.tell = res.value.phone
        // console.log('客服电话', res)
      })
    }
  },
  mounted: function(){
    this.getTell()
  }
}
</script>

<style scoped>
.service-container{
  width: 850px;
  background:#fff;
  height: 500px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}
.service-container h3{
  width: 72px;
  height: 18px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 18px;
  margin: 30px;
}
.service-container p{
  height: 16px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252525;
  line-height: 16px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccMyTool/children/service.vue